var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"h-100",attrs:{"body-class":"margin-top-fixed-header px-0"}},[_c('fixed-header',{attrs:{"title":"Add Part"}}),_c('part-form',{attrs:{"partId":_vm.partId},on:{"cancel":_vm.onClose,"partCreated":_vm.onPartCreated}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }